import React, { useState } from 'react';
import { WorkbenchQueryEditorDialog } from './WorkbenchQueryEditorDialog';
import {
  CollapsibleWorkbenchQueryEditor,
  WorkbenchQueryEditorProps
} from './CollapsibleWorkbenchQueryEditor';

export function WorkbenchQueryEditorContainer(props: WorkbenchQueryEditorProps) {
  const [ isExpandedView, setIsExpandedView ] = useState(false);

  const toggleExpandedView = () => {
    setIsExpandedView((state) => !state);
  };

  return (<>
    <CollapsibleWorkbenchQueryEditor
      {...props}
      toggleExpandedView={toggleExpandedView}
    />

    <WorkbenchQueryEditorDialog
      {...props}
      open={isExpandedView}
      toggleExpandedView={toggleExpandedView}
    />
  </>);
}
